<div class="panel panel-default widget-support-tickets">
  <div class="panel-heading">

    <span class="panel-title" *ngIf="!hcpId">{{'app.create' | translate}}</span>
    <span class="panel-title" *ngIf="hcpId">{{'app.editTile' | translate}}</span>
  </div>
  <div class="panel-body padding-sm-hr">
    <div class="form-group no-margin-hr panel-padding-h no-padding-t no-border-t">
      <div class="container text-center" *ngIf="displayMode==1">
        <i class="fa fa-spinner fa-spin" style="font-size:48px;color:darkseagreen"></i> <p>{{'app.Loading' | translate}}</p>
      </div>
      <form #f="ngForm" *ngIf="displayMode==2"
            novalidate (ngSubmit)="save(f)">
        <div class="row padding-sm-vr" *ngIf="!hcpId">
          <div class="col-sm-8">
            <span>{{'app.enterDataOrUpload' | translate}}</span>
          </div>
          <div class="col-sm-2"></div>
          <div class="col-sm-2 cursor-pointer left-6">
            <span class="margin-right-7 edit-profile-span" (click)="showProvisionModal()">{{'app.provision' | translate}}</span>
            <i class="fa fa-upload" aria-hidden="true"></i>
          </div>
        </div>

        <div class="row padding-sm-vr">
          <div class="col-sm-4"  *ngIf="!editFromList || canEditHcpsEnglishNamePermission">
            <div [ngClass]="{'has-success': (firstName.dirty || firstName.touched || f.submitted)  && firstName.valid, 'has-error' : (firstName.dirty || firstName.touched || f.submitted)  && firstName.invalid}">
              <label class="control-label">Name <i>*</i></label>
              <input type="text"
                     name="firstName"
                     [(ngModel)]="hcp.fullName"
                     (blur)="hcp.fullName = normalizeWhitespace(hcp.fullName)"
                     #firstName="ngModel"
                     required="required"
                     class="form-control" />
              <div *ngIf="(firstName.dirty || firstName.touched || f.submitted)  && firstName.invalid" class="jquery-validate-error help-block">
                {{'app.RequiredField' | translate}}
              </div>
            </div>
          </div>

          <div class="col-sm-4"  *ngIf="(!editFromList || canEditHcpsArabicNamePermission) && showEnglishName">
            <div [ngClass]="{'has-success': (middleName.dirty || middleName.touched || f.submitted)  && middleName.valid, 'has-error' : (middleName.dirty || middleName.touched || f.submitted)  && middleName.invalid}">
              <label class="control-label">{{englishNameLabel}} </label>
              <input type="text"
                     name="middleName"
                     [(ngModel)]="hcp.englishName"
                     #middleName="ngModel"
                      
                     class="form-control" />
              <div *ngIf="(middleName.dirty || middleName.touched || f.submitted)  && middleName.invalid" class="jquery-validate-error help-block">
                {{'app.RequiredField' | translate}}
              </div>
            </div>
          </div>
         
        </div>
        <div class="row padding-sm-vr">
           
          <div class="col-sm-4"  *ngIf="!editFromList || canEditHcpsPhonePermission">
            <div [ngClass]="{'has-success': (phone.dirty || phone.touched || f.submitted)  && phone.valid, 'has-error' : (phone.dirty || phone.touched || f.submitted)  && phone.invalid}">
              <label class="control-label">{{'pageHeader.phone' | translate}}   </label>
              <input type="text"
                     name="phone"
                     [(ngModel)]="hcp.phone"
                     #phone="ngModel"
                    
                     class="form-control" />
              <div *ngIf="(phone.dirty || phone.touched || f.submitted)  && phone.invalid" class="jquery-validate-error help-block">
                {{'app.RequiredField' | translate}}
              </div>
            </div>
          </div>
          <div class="col-sm-4"  *ngIf="!editFromList || canEditHcpsMailPermission">
            <div [ngClass]="{'has-success': (email.dirty || email.touched || f.submitted)  && email.valid, 'has-error' : (email.dirty || email.touched || f.submitted)  && email.invalid}">
              <label class="control-label">{{'pageHeader.email' | translate}}   </label>
              <input type="email"
                     name="email"
                     [(ngModel)]="hcp.email"
                     #email="ngModel"
                     
                     class="form-control" />
              <div *ngIf="(email.dirty || email.touched || f.submitted)  && email.invalid" class="jquery-validate-error help-block">
                {{'app.RequiredField' | translate}}
              </div>
            </div>
          </div>


        </div>

        <div class="row padding-sm-vr">
          <div class="col-sm-6"  *ngIf="!editFromList || canEditHcpsSpecialityPermission">
            <div [ngClass]="{'has-success': (specialityId.dirty || specialityId.touched || f.submitted)  && specialityId.valid, 'has-error' : (specialityId.dirty || specialityId.touched || f.submitted)  && specialityId.invalid}">
              <label class="control-label">{{'pageHeader.Speciality' | translate}}  <i>*</i></label>


              <select id="specialityId" name="specialityId" [(ngModel)]="hcp.specialityId" #specialityId="ngModel" #specialitiesSelector="bootstrap-select" class="selectpicker form-control" bootstrapSelect required
                      data-live-search="true" data-actions-box="false" data-live-search-placeholder="Search..." title="Select Speciality">
                <option *ngFor="let item of specialities" attr.data-content="<span title='{{item.name}}' class='badge'>{{item.name }}</span>" attr.value="{{item.id}}">
                  {{item.name}}
                </option>
              </select>
              <div *ngIf="(specialityId.dirty || specialityId.touched || f.submitted)  && specialityId.invalid" class="jquery-validate-error help-block">
                {{'app.RequiredField' | translate}}
              </div>
            </div>
          </div>
          <div class="col-sm-6" *ngIf="false">
            <div [ngClass]="{'has-success': (classId.dirty || classId.touched || f.submitted)  && classId.valid, 'has-error' : (classId.dirty || classId.touched || f.submitted)  && classId.invalid}">
              <label class="control-label">{{'hco.classes' | translate}} <i>*</i></label>

              <span class="ui-fluid">
                <p-dropdown [options]="hCPClasses"
                            placeholder="{{'hco.classes' | translate}}"
                            emptyFilterMessage="No results found"
                            showClear="true"
                            styleClass="wid100"
                            [styleClass]="form-control"
                            name="classId"
                            #classId="ngModel"
                            [(ngModel)]="hcp.class"
                            [filter]="true" optionLabel="name">
                </p-dropdown>
              </span>
              <div *ngIf="(classId.dirty || classId.touched || f.submitted)  && classId.invalid" class="jquery-validate-error help-block">
                {{'app.RequiredField' | translate}}
              </div>
            </div>
          </div>
          <div class="col-sm-6" *ngIf="false">
            <div [ngClass]="{'has-success': (itemBrandId.dirty || itemBrandId.touched || f.submitted)  && itemBrandId.valid, 'has-error' : (itemBrandId.dirty || itemBrandId.touched || f.submitted)  && itemBrandId.invalid}">
              <label class="control-label">{{'representation.itemsBrands' | translate}} <i>*</i></label>

              <span class="ui-fluid">
                <p-dropdown [options]="itemBrands"
                            placeholder="{{'representation.itemsBrands' | translate}}"
                            emptyFilterMessage="No results found"
                            showClear="true"
                            styleClass="wid100"
                            [styleClass]="form-control"
                            name="itemBrandId"
                            #itemBrandId="ngModel"
                            [(ngModel)]="hcp.itemBrand"
                            [filter]="true" optionLabel="name">
                </p-dropdown>
              </span>
              <div *ngIf="(itemBrandId.dirty || itemBrandId.touched || f.submitted)  && itemBrandId.invalid" class="jquery-validate-error help-block">
                {{'app.RequiredField' | translate}}
              </div>
            </div>
          </div>
          <div class="col-sm-6" *ngIf="!hcpId || reviewMode">
            <label class="control-label">{{'Hcos' | translate}} </label>
            <ng-multiselect-dropdown [placeholder]="'Hcos'"
                                     [data]="hcos"
                                     name="hco"
                                     #hco="ngModel"
                                     #hcosDropdownEl
                                     (onFilterChange)="onHcosFilterChange($event)"
                                     [(ngModel)]="selectedHcos"
                                     [settings]="dropdownSettings">
            </ng-multiselect-dropdown>
          </div>
        

        </div>
        <div class="row padding-sm-vr"  *ngIf="!editFromList || canEditHcpsActiveStatusPermission">
          <div class="col-sm-6">
            <div [ngClass]="{'has-success': (active.dirty || active.touched || f.submitted)  && active.valid, 'has-error' : (active.dirty || active.touched || f.submitted)  && active.invalid}">
              <label class="control-label">{{'app.active' | translate}} </label>

              <div class="form-group">
                <div class="checkbox">
                  <label><input type="checkbox" #active="ngModel" name="active" [(ngModel)]="hcp.active">{{'app.active' | translate}}  </label>
                </div>
              </div>
            </div>
          </div>
          <div class="col-sm-6"  *ngIf="!editFromList || canEditHcpsGoldenListPermission">
            <div [ngClass]="{'has-success': (goldenList.dirty || goldenList.touched || f.submitted)  && goldenList.valid, 'has-error' : (goldenList.dirty || goldenList.touched || f.submitted)  && goldenList.invalid}">
              <label class="control-label">{{'GoldenL ist' | translate}} </label>

              <div class="form-group">
                <div class="checkbox">
                  <label><input type="checkbox" #goldenList="ngModel" name="goldenList" [(ngModel)]="hcp.goldenList">{{'Golden List' | translate}}  </label>
                </div>
              </div>
            </div>
          </div>
        </div>


        <div class="panel-footer margin-left-20 margin-top-20 margin-left-37">
          <button class="btn  btn-cancel" type="button" (click)="back()">{{'app.cancel' | translate}}</button>&nbsp;
          <button class="btn  btn-save" type="submit" *ngIf="!hcpId && !reviewMode">{{'app.create' | translate}}</button>
          <button class="btn  btn-save" type="submit" *ngIf="hcpId && !reviewMode">{{'app.save' | translate}}</button>
          <button class="btn  btn-save" type="button" *ngIf="reviewMode" (click)="cofirmHcp(hcp)">{{'app.confirm' | translate}}</button>&nbsp;
          <button class="btn  btn-save" type="button" *ngIf="reviewMode" (click)="rejectAddRequest(hcp)">{{'app.reject' | translate}}</button>

        </div>
      </form>
    </div>
  </div>

</div>

<div class="row col-sm-12 padding-sm-hr" *ngIf="displayMode==3">
  <div class="alert alert-danger alert-dark">
    <button type="button" class="close" data-dismiss="alert">×</button>
    {{'app.ServerError' |translate}}.
  </div>
</div>




<div class="modal fade" bsModal #rejectModal="bs-modal" [config]="{backdrop: 'static'}" tabindex="-1">
  <div class="modal-dialog modal-lg">
    <div class="panel padding-2">
      <div>
        <h1 class="delete-title">{{'hco.rejectFileQuestionTitle' | translate}}</h1>
      </div>
      <div class="row panel-body padding-sm-hr padding-top-0 padding-bottom-0">

        <div class="panel-footer margin-left-20 margin-top-20">
          <button type="button" (click)="hideRejectModal()" class="btn btn-cancel">{{'app.cancel' | translate}}</button>
          <button type="button" class="btn btn-save" (click)="deleteHCP()">{{'app.reject' | translate}}</button>
        </div>
      </div>
    </div>
  </div>
</div>
